import { ReactNode } from "react";
import { church } from "./church";

interface Props {
    className?: string;
}

interface LogoProps extends Props {
    /** What stands in until the church has a logo; its name, unless the screen already says it */
    fallback?: ReactNode;
}

/** The church's logo, or its name set in type until it has one */
export const ChurchLogo = ({
    className,
    fallback = <span className="block text-center text-2xl font-extrabold tracking-tight">{church.name}</span>,
}: LogoProps) =>
    church.images.logo ? <img src={church.images.logo} alt={church.name} className={className} /> : <>{fallback}</>;

/** The church's mark, or nothing until it has one */
export const ChurchMark = ({ className }: Props) =>
    church.images.mark ? <img src={church.images.mark} alt="" className={className} /> : null;
